function hasVerified(field) {
  return field === 'pending' || field === 'verified'
}
export default hasVerified
